import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { getToken } from '../../adalConfig';
import axios from 'axios';
import Loader from '../../component/Loader/Loader';
import { authContext } from "../../adalConfig";
import { requestIp  } from 'request-ip';



class AzureLogin extends Component {

    componentDidMount() {
        const token = getToken()
        if (token) {
            const url = process.env.REACT_APP_GETAUTHENTICATED
            
           

            let headers = {
                'Accept': 'application/json',
                'ClientIP': 'clientIp'
            };

            headers["Authorization"] = `Bearer ${getToken()}`;
            
            console.log(headers)

            axios.get(url, { headers }).then((response) => {
                const result = response.data;
                console.log(result)
                if (result.isAuthenticated && result.usertype) {

                    if(!result.sessionExpired)
                    {
                        if(!result.multiActiveSessions)
                        {
                            const url = process.env.REACT_APP_LOGSIGNIN
                            let headers = {
                                'Content-Type': 'multipart/form-data'
                            };

                            headers["Authorization"] = `Bearer ${getToken()}`;

                            const form = new FormData();
                            form.append('userid', result.id);

                            // for (var pair of form.entries()) {
                            //     console.log(pair[0] + ', ' + pair[1]);
                            // }

                            axios.post(url, form, { headers: headers }).then((response) => {
                                console.log('Response Status', response.status)
                                if (response.status === 200) {
                                    localStorage.setItem('id', result.id)
                                    this.props.history.push({
                                        pathname: '/PhotoGuide',
                                        state: {
                                            login: result.login,
                                            studentID: result.id,
                                            userType: result.usertype,
                                            accesstoken: token
                                        }
                                    })
                                } else {
                                    this.props.history.push({
                                        pathname: '/',
                                        state: {
                                            error: 'Unable to Sign in to Sharepoint'
                                        }
                                    })
                                }
                            }).catch((error) => {
                                console.log('error', error)
                                const url = process.env.REACT_APP_LOGEXCEPTION
                                let headers = {
                                    'Content-Type': 'multipart/form-data'
                                };

                                headers["Authorization"] = `Bearer ${getToken()}`;

                                const form = new FormData();
                                form.append('loggedinuserid', localStorage.getItem('id'))
                                form.append('student_staff_id', localStorage.getItem('id'));
                                form.append('webapimethodname', url);

                                if (error.response) {
                                    form.append('error', error.response.status + ' ' + error.response.statusText);
                                } else {
                                    form.append('error', error.message);
                                }

                                for (var pair of form.entries()) {
                                    console.log(pair[0] + ', ' + pair[1]);
                                }

                                axios.post(url, form, { headers: headers }).then((response) => {
                                    let errorMsg = error.message + ". Unable to Sign in to Sharepoint";
                                    if (error.response) {
                                        errorMsg = error.response.status + ' ' + error.response.statusText;
                                    }
                                    this.props.history.push({
                                        pathname: '/',
                                        state: {
                                            error: errorMsg
                                        }
                                    })
                                }).catch((error) => {
                                    let errorMsg = error.message + ". Unable to Sign in to Sharepoint";
                                    if (error.response) {
                                        errorMsg = error.response.status + ' ' + error.response.statusText;
                                    }
                                    this.props.history.push({
                                        pathname: '/',
                                        state: {
                                            error: errorMsg
                                        }
                                    })
                                });
                            });
                        }
                        else {                            
                            this.props.history.push({
                                pathname: '/',
                                state: {
                                    error: 'You already have an Active Session. Please continue the same or log out!',
                                    showlogout: true
                                },
                                showText:true,
                                Loader:false
                            })                    
                        }
                }
                else {
                    
                    this.props.history.push({
                        pathname: '/',
                        state: {
                            error: 'Session Expired! Please login again.',
                            showlogout: false
                        },
                        showText:true,
                        Loader:false
                    }) 
                                   
                }
                } else {                    
                    this.props.history.push({
                        pathname: '/',
                        state: {
                            error: 'Logged in User is not identified in Photo system'
                        }
                    })
                }
            }).catch((error) => {
                console.log('error', error)
                const url = process.env.REACT_APP_LOGEXCEPTION
                let headers = {
                    'Content-Type': 'multipart/form-data'
                };

                headers["Authorization"] = `Bearer ${getToken()}`;

                const form = new FormData();
                form.append('loggedinuseridstring', this.state.StudentID)
                form.append('student_staff_idstring', this.state.StudentID);
                form.append('webapimethodnamestring', url);

                if (error.response) {
                    form.append('errorstring', error.response.status + ' ' + error.response.statusText);
                } else {
                    form.append('errorstring', error.message);
                }

                for (var pair of form.entries()) {
                    console.log(pair[0] + ', ' + pair[1]);
                }

                axios.post(url, form, { headers: headers }).then((response) => {
                    let errorMsg = "Something went wrong"
                    if (error.response) {
                        errorMsg = error.response.status + ' ' + error.response.statusText;
                    } else {
                        if (error.message) {
                            errorMsg = error.message;
                        }
                    }
                    this.props.history.push({
                        pathname: '/',
                        state: {
                            error: errorMsg
                        }
                    })
                }).catch((error) => {
                    let errorMsg = "Something went wrong"
                    if (error.response) {
                        errorMsg = error.response.status + ' ' + error.response.statusText;
                    } else {
                        if (error.message) {
                            errorMsg = error.message;
                        }
                    }
                    this.props.history.push({
                        pathname: '/',
                        state: {
                            error: errorMsg
                        }
                    })
                });
            });
        }
    }

    render() {
        return (
            <Loader showText={true} />
        );
    }

}

export default withRouter(AzureLogin);